import React, { useState } from 'react';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { styled } from '@this/constants/themes';
import type HotelBaseScore from '@this/domain/hotel_base_score';
import { Fetcher, HTTPError } from '@this/src/util';
import Notification from '../../../notification';

type Props = {
  scores: HotelBaseScore[];
};

const HotelBaseScoresForm: React.FC<Props> = ({ scores }) => {
  const [errors, setErrors] = useState<string[]>([]);

  const updateHotelBaseScore = async (s: HotelBaseScore) => {
    setErrors([]);
    try {
      await Fetcher.put(`/admin/repository_display_adjustment/hotel_base_scores/${s.id}.json`, s.submitParams());
      Notification.success('ホテル基本スコアを更新しました');
    } catch (e) {
      if (e instanceof HTTPError && e.response?.status === 400) {
        const permissionMessage = e.response.data.message;
        const validationErrors = e.response.data.errors;
        setErrors(validationErrors || [permissionMessage]);
      } else {
        setErrors(['通信エラーが発生しました。時間をおいて再度お試しください。']);
      }
    }
  };

  return (
    <>
      {scores.map((s, i) => (
        <Form
          key={i}
          onSubmit={e => {
            e.preventDefault();
            updateHotelBaseScore(s);
          }}
        >
          <Label htmlFor={s.provider}>{s.provider}</Label>
          <Input
            id={s.provider}
            type="number"
            step="0.1"
            value={s.value}
            onChange={e => {
              s.value = Number(e.target.value);
            }}
          />
          <button type="submit">更新</button>
        </Form>
      ))}
      {!_.isEmpty(errors) &&
        errors.map((e, i) => (
          <p key={i} className="error">
            {e}
          </p>
        ))}
    </>
  );
};

const Form = styled.form`
  display: flex;
  align-items: center;
  margin: 5px 0;
`;

const Label = styled.label`
  width: 200px;
`;

const Input = styled.input`
  width: 100px !important;
  margin: 0 10px !important;
`;

export default observer(HotelBaseScoresForm);
